import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const ProfileButtonsDefaultBox = styled.div`
    // 888 // 777 // delaware // doverdowns // harrington
    padding: 0 1rem;
`;
const ProfileButtonsHarrahsWsopBox = styled.div`
    // harrahs // wsop
    padding: 0 1.5rem;
`;

export const ProfileButtonsBox = styledByTheme(ProfileButtonsDefaultBox).forHarrahs(ProfileButtonsHarrahsWsopBox).forWsop(ProfileButtonsHarrahsWsopBox).apply();
